export const prefersReducedMotion = () => {
  try {
    return window.matchMedia('(prefers-reduced-motion)').matches
  } catch {
    return false
  }
}
